export const SERVICE_ROUTES = [
  {
    path: 'services',
    name: 'ServiceList',
    component: () => import('./services/views/ServiceList.vue'),
  },
  {
    path: 'services/create',
    name: 'CreateService',
    component: () => import('./services/views/CreateService.vue'),
  },
  {
    path: 'services/:serviceId/edit',
    name: 'EditService',
    component: () => import('./services/views/EditService.vue'),
  },
  {
    path: 'services/:serviceId/substrates/create',
    name: 'CreateSubstrate',
    component: () => import('./substrates/views/CreateSubstrate.vue'),
  },
  {
    path: 'services/:serviceId/substrates/:substrateId/edit',
    name: 'EditSubstrate',
    component: () => import('./substrates/views/EditSubstrate.vue'),
  },
  {
    path: 'services/:serviceId/substrates/:substrateId/items/create',
    name: 'CreateItem',
    component: () => import('./items/views/CreateItem.vue'),
  },
  {
    path: 'services/:serviceId/substrates/:substrateId/items/:itemId/edit',
    name: 'EditItem',
    component: () => import('./items/views/EditItem.vue'),
  },
]
